export default "__VITE_ASSET__ue2laY5c__"